import api from '../..'

const destroyMany = (ids: (string | number)[]) => {
  return api.delete(`administration/external_course_participants`, {
    data: { ids },
  })
}

export default destroyMany
